// removed by extract-text-webpack-plugin
module.exports = {"dialog":"dialog__dialog___1Khws","active":"dialog__active___23vvd","small":"dialog__small___3liod","normal":"dialog__normal___DTV1T","large":"dialog__large___3GQil","fullscreen":"dialog__fullscreen___16cs0","title":"dialog__title___18F47","body":"dialog__body___2WEBV","navigation":"dialog__navigation___MXm2I","button":"dialog__button___3wUOV","fadeUp":"dialog__fadeUp___1roF8","lateFadeUp":"dialog__lateFadeUp___1OShZ","lateFadeIn":"dialog__lateFadeIn___196Wy"};


//////////////////
// WEBPACK FOOTER
// ./client/styles/react-toolbox/dialog.scss
// module id = 963
// module chunks = 0